import React from 'react';
import NavResponsiveModal, {
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/components/Navigation/NavResponsiveModal';
import { PrimaryButton, SecondaryButton } from '@/styles/blocks';
import { Body1 } from '@/components/Account/blocks';

const DeleteTariffModal = ({ open, onCancel, onConfirm }) => (
    <NavResponsiveModal open={open} onClose={onCancel}>
        <ModalHeader title="Delete Tariff?" onClose={onCancel} />
        <ModalContent>
            <Body1>Are you sure you want to delete this tariff?</Body1>
        </ModalContent>
        <ModalActions>
            <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
            <PrimaryButton onClick={onConfirm}>Delete</PrimaryButton>
        </ModalActions>
    </NavResponsiveModal>
);

export default DeleteTariffModal;
